module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "chapter-title1"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/illustrations"
    }
  }, [_c('em', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/front1"
    }
  }, [_c('em', [_vm._v("Octave Designation Chart")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface01"
    }
  }, [_c('em', [_vm._v("Preface to the Second Edition")]), _vm._v("    JEFFERY KITE-POWELL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface02"
    }
  }, [_c('em', [_vm._v("Preface to the First Edition")]), _vm._v("    STEWART CARTER")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgments"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1"
    }
  }, [_c('strong', [_vm._v("PART 1.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part1"
    }
  }, [_vm._v("VOCAL/CHORAL ISSUES")])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01"
    }
  }, [_vm._v("1. National Singing Styles    SALLY SANFORD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/chap02"
    }
  }, [_vm._v("2. The "), _c('em', [_vm._v("Bel Canto")]), _vm._v(" Singing Style    JULIANNE BAIRD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/chap03"
    }
  }, [_vm._v("3. Choral Music in France and England    ANNE HARRINGTON HEIDER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3b"
  }, [_c('span', {
    attrs: {
      "href": "#/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Choral Music in Italy and the Germanic Lands    GARY TOWNE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART 2.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WIND, STRING, AND PERCUSSION INSTRUMENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Woodwinds HERBERT MYERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Cornett and Sackbut BRUCE DICKEY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Trombone STEWART CARTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Trumpet and Horn STEVEN E. PLANK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Percussion Instruments and Their Usage JOHN MICHAEL COOPER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Violin: Technique and Style DAVID DOUGLASS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Historical Approaches to Playing the Violin JULIE ANDRIJESKI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Viola da Gamba Family STUART CHENEY WITH BARBARA COEYMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Violoncello and Violone MARC VANSCHEEUWIJCK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Keyboard Instruments MARK KROLL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3b"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Plucked String Instruments PAUL O'DETTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART 3.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PERFORMANCE PRACTICE AND PRACTICAL CONSIDERATIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Ornamentation in Early Seventeenth-Century Italian Music BRUCE DICKEY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. "), _c('em', [_vm._v("Basso Continuo")]), _vm._v("  JACK ASHWORTH AND PAUL O'DETTE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Meter and Tempo GEORGE HOULE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Tuning and Temperament HERBERT MYERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3b"
  }, [_c('span', {
    attrs: {
      "href": "#/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Pitch and Transposition HERBERT MYERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART 4.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SEVENTEENTH-CENTURY STAGE")])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Dance DOROTHY OLSSON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3b"
  }, [_c('span', {
    attrs: {
      "href": "#/chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Teatrical Productions JAMES MIDDLETON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A. List of Names and Dates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B. "), _c('em', [_vm._v("A Performer's Guide to Medieval Music:")]), _vm._v(" Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C. "), _c('em', [_vm._v("A Performer's Guide to Renaissance Music:")]), _vm._v(" Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/contributors",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("List of Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b833b32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 69
// module chunks = 0